import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@aqarmap/aqarmap-ui';
import queryString from 'query-string';
import PageLayout from '~myAccount/components/PageLayout';
import TransactionsList from '~myAccount/pages/Wallet/TransactionsList';
import TransactionsFilter from '~myAccount/pages/Wallet/TransactionsFilter';
import { FiltersType } from '~myAccount/pages/Wallet/types';
// import { useLazyGetTransactionsQuery } from '~/redux/api/walletApiSlice';
// import { TransactionType } from '~/types/walletTypes';
import WalletLoader from '~myAccount/pages/Wallet/WalletLoader';
import TopupModal from '~/modules/myAccount/pages/Wallet/TopupModal';
import EmptyWallet from '~myAccount/pages/Wallet/EmptyWallet';
import { useAppDispatch } from '~/redux/hooks';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import Pagination from '~/components/Pagination';
import WalletBalance from '~myAccount/pages/Wallet/WalletBalance';
import { useWallet } from '~/hooks';

const Wallet = () => {
  const limit = 10;
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const dispatch = useAppDispatch();
  const [filters, setFilters] = useState<FiltersType>(null);
  const [page, setPage] = useState<number>(1);

  const params = useMemo(() => {
    return queryString.stringify(
      { page, limit, ...filters },
      { arrayFormat: 'bracket', skipEmptyString: true },
    );
  }, [page, limit, filters]);

  const {
    transactions,
    walletBalance,
    userHasWallet,
    paginate,
    isWalletLoading,
    isWalletFetching,
  } = useWallet({
    locale,
    params,
  });

  return (
    <>
      <PageLayout
        bodyClassName="border border-gray rounded-[8px]"
        title={t('wallet')}
        ctas={
          userHasWallet ? (
            <Button
              size="medium"
              variant="primary"
              onClick={() => dispatch(openModal('topUpModal'))}
            >
              {t('addBalance')}
            </Button>
          ) : null
        }
      >
        {isWalletLoading ? (
          <WalletLoader />
        ) : !userHasWallet ? (
          <EmptyWallet />
        ) : (
          <div className="flex flex-col gap-4x md:gap-3x px-2x md:px-3x py-3x">
            {walletBalance !== undefined && (
              <WalletBalance balance={walletBalance} />
            )}
            <div className="flex flex-col gap-3x">
              <TransactionsFilter
                onChange={(values) => {
                  setPage(1);
                  setFilters((prev) => ({ ...prev, ...values }));
                }}
              />

              <TransactionsList
                transactions={transactions ?? []}
                isLoading={isWalletFetching}
              />
              <Pagination
                currentPage={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                totalCount={paginate?.totalCount || 0}
                limit={limit}
              />
            </div>
          </div>
        )}
      </PageLayout>
      <TopupModal />
    </>
  );
};

export default Wallet;
